import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

const socialLinks = [
  { href: "https://twitter.com/codehouze", icon: faTwitter, label: "Twitter" },
  { href: "https://www.linkedin.com/in/codehouze/", icon: faLinkedin, label: "LinkedIn" },
  { href: "https://www.github.com/codehouze/", icon: faGithub, label: "GitHub" },
];

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="mx-auto max-w-6xl px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Emmanuel Maxwell. Built with React & Tailwind.
          </p>
          <div className="flex items-center gap-5">
            {socialLinks.map(({ href, icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="text-gray-500 hover:text-emerald-400 transition-colors duration-200"
              >
                <FontAwesomeIcon icon={icon} className="text-xl" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
